import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function sanitizePhoneNumber(value) {
  return value?.toString().replace(/\+/g, "")
}
